module.exports = __webpack_public_path__ + "media/application/images/2018/icon-peoples-choice-4f90b490e9d3bd80a8c22082e3cb4aad.svg";